import { EditAccessGroupGeneralForm } from '../../components/EditAccessGroupGeneralForm';
import { Box, Typography } from '@servicepipe/ui-components';
import React from 'react';

export const EditAccessGroupGeneral = ({ accessGroup, loading, refetch }) => {
  if (loading) {
    return (
      <Box>
        <Typography variant="body1">Loading...</Typography>
      </Box>
    );
  }

  if (!accessGroup) {
    return (
      <Box>
        <Typography variant="body1">Access group not found.</Typography>
      </Box>
    );
  }

  return (
    <Box direction="column" gap="24px">
      <Typography variant="h6">General</Typography>
      <EditAccessGroupGeneralForm accessGroup={accessGroup} onUpdated={refetch} />
    </Box>
  );
};

export default EditAccessGroupGeneral;
